export enum NineLayoutTag {
  TOP_LEFT = 'top-left top left nine-layout',
  TOP_MIDDLE = 'top-mid mid top nine-layout',
  TOP_RIGHT = 'top-right top right nine-layout',
  MIDDLE_LEFT = 'mid-left mid left nine-layout',
  MIDDLE_MIDDLE = 'mid-mid mid nine-layout',
  MIDDLE_RIGHT = 'mid-right mid right nine-layout',
  BOTTOM_LEFT = 'bottom-left bottom left nine-layout',
  BOTTOM_MIDDLE = 'bottom-mid mid bottom nine-layout',
  BOTTOM_RIGHT = 'bottom-right bottom right nine-layout',
}
